// extracted by mini-css-extract-plugin
module.exports = {"responseContainer":"styles_responseContainer__ME1bf","header":"styles_header__xIDrE","title":"styles_title__z6mWY","date":"styles_date__iOcIK","text":"styles_text__n76rp"};